import React from 'react';
import {useState} from 'react'
import { useSelector } from 'react-redux';

import { Checkbox } from 'material-ui';
import ShowMoreButton from 'ui-components/ShowMoreButton';
import UpButton from 'ui-components/UpButton';
import GroupedItems from '../grouped-items/GroupedItems'

import './bad-fit-table.scss'

const BadFitTable = () => {
    const [itemsToShow, setItems] = useState(1)
    const badFitItems = useSelector(state => (state.admin && state.admin.badFitItems) || [])

    const buttonHandler = () => {
        setItems(prev => prev + 1)
    }

    const collapseHandler = () => {
        setItems(1)
    }

    const badFitList = badFitItems.slice(0, itemsToShow)
    return (
        <div className='bad-fit-table'>
            <section className="invoice-line-item-container">
                <article className="invoice-line-item header bad-fit-head">
                    <span className="flex-20" style={{flex: "10% 0.5"}}>Client Name</span>
                    <span className="flex-20" style={{flex: "10% 0.5"}}>Counsellor Name</span>
                    <span className="flex-20" style={{flex: "12% 2"}}>Notes</span>
                </article>
                {
                    badFitList.map(group => {
                        if (group.items.length) {
                            return (
                                <GroupedItems
                                    key={group.date}
                                    items={group.items}
                                    date={group.date}
                                />
                            )
                        }
                    })
                }
            </section>
            <ShowMoreButton
                onClick={buttonHandler}
                disabled={badFitItems.length === itemsToShow}
            />
            {
                itemsToShow > 1  &&
                    <UpButton
                        onClick={collapseHandler}
                    />
            }
        </div>
    );
};

export default BadFitTable;
